import { GET_USER_BILLING_INFO_FAILURE, GET_USER_BILLING_INFO_REQUEST, GET_USER_BILLING_INFO_RESET, GET_USER_BILLING_INFO_SUCCESS } from "../../../../redux/types/pvs"


const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const getUserBillingDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_BILLING_INFO_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case GET_USER_BILLING_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      }

    case GET_USER_BILLING_INFO_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: ""
      }

    case GET_USER_BILLING_INFO_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default getUserBillingDetailsReducer
